import {FC, useEffect, useState} from 'react'
import {FocusedInputShape} from 'react-dates'
import {SearchComponent} from '_metronic/assets/ts/components'
import {KTSVG} from '_metronic/helpers'
import find from 'lodash/find'
import {useDispatch} from 'react-redux'
import {firstNYear, lastNYear, formatToDateString2} from 'app/format/date'
import moment from 'moment'
import {getDateRange} from './DateRanges'
import DateRangePicker from '_core/components/DateRangePicker'

type Props = {
  onFilterChange: any
  _filter: any
}

const DateRangeFilter: FC<Props> = ({onFilterChange, _filter}) => {
  const dispatch = useDispatch()
  const [dateFilters, setDateFilters] = useState<any>([])
  const [filter, setFilter] = useState<any>(_filter || {})
  const [focusedInput, setFocusedInput] = useState<FocusedInputShape | null>(null)
  const [error, setError] = useState<any>('')

  useEffect(() => {
    SearchComponent.createInsance('#kt_date_filter')
    const dateRangeFilters = getDateRange([])
    setDateFilters(dateRangeFilters)
  }, [dispatch])

  const handleSelectChange = (e: any) => {
    const {value: id} = e.target
    const selectValue = find(dateFilters, {id})
    setFilter({...selectValue, isCustomRange: false})
    setError('')
  }

  const handleDatesChange = (prop: any) => {
    const {startDate: fromDate, endDate: toDate} = prop
    const newFilter = {...filter, fromDate, toDate, isCustomRange: true}
    setFilter(newFilter)
    validate(fromDate, toDate)
  }

  const validate = (fromDate: any, toDate: any) => {
    if (fromDate === null && toDate === null) {
      setError('From date and to date is not valid')
    } else if (toDate === null || fromDate === null) {
      setError((!fromDate && 'From date is not valid') || (!toDate && 'To date is not valid'))
    } else {
      setError('')
    }
  }

  const handleOutsideOfRange = (year: any) =>
    year.isAfter(firstNYear(year, 1)) || year.isBefore(lastNYear(year, 5))

  const handleClear = () => {
    setFilter({})
    setError('')
    onFilterChange()
  }

  if (!filter) {
    return <div>Loading</div>
  }

  return (
    <div
      id='kt_date_filter'
      className='d-flex align-items-stretch w-100'
      data-kt-menu-trigger='auto'
      data-kt-menu-overflow='false'
      data-kt-menu-permanent='true'
      data-kt-menu-placement='bottom-start'
    >
      <div className='dropdown' data-kt-search-element='toggle' id='kt_date_filter_toggle'>
        <button
          id='btnDateFilter'
          type='button'
          data-kt-search-element='input'
          className='border-left-0 px-4 btn p-2 w-100 btn-tab rotate fs-6 btn-active-color-text-primary justify-content-center border border-gray-400 rounded-0 hide-toggle min-w-100px mt-1 dropdown-toggle btn btn-transparent'
        >
          {filter.isCustomRange ? (
            <>
              {formatToDateString2(filter.fromDate) === formatToDateString2(filter.toDate) ? (
                formatToDateString2(filter.toDate)
              ) : (
                <>
                  {formatToDateString2(filter.fromDate)} - {formatToDateString2(filter.toDate)}
                </>
              )}
            </>
          ) : (
            filter.text || 'All Days'
          )}
          <KTSVG path='/media/icons/duotune/general/gen014.svg' className='svg-icon-2 ps-2' />
        </button>
      </div>

      <div
        data-kt-search-element='content'
        className='menu menu-sub menu-sub-dropdown p-7 w-300px w-md-350px'
      >
        <div data-kt-search-element='wrapper'>
          <div className='d-flex flex-column  py-5'>
            <div className='mb-5'>
              <label className='form-label fw-bolder'>Date Range</label>
              <select
                id='selectData'
                className='form-select form-select-solid'
                data-kt-select2='true'
                data-placeholder='Select option'
                onChange={handleSelectChange}
              >
                <option selected hidden>
                  Select Date Range
                </option>
                {dateFilters.map((filter: any) => (
                  <option value={filter.id} key={filter.id}>
                    {filter.text}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className='d-flex flex-column py-5'>
            {/* {filter.fromDate && ( */}
            <>
              <label className='form-label fs-6 fw-bolder '>Custom Range</label>
              <div>
                <DateRangePicker
                  startDate={formatDate(filter.fromDate)}
                  endDate={formatDate(filter.toDate)}
                  startDateId='fromDate'
                  endDateId='toDate'
                  minimumNights={0}
                  onDatesChange={handleDatesChange}
                  focusedInput={focusedInput}
                  onFocusChange={(focusedInput) => setFocusedInput(focusedInput)}
                  noBorder={true}
                  isOutsideRange={handleOutsideOfRange}
                  hideKeyboardShortcutsPanel={true}
                />
                {error && (
                  <div className='fv-plugins-message-container invalid-feedback'>
                    <i className='bi bi-exclamation-circle-fill text-danger me-2'></i>
                    <span role='alert'>{error}</span>
                  </div>
                )}
              </div>
            </>
            {/* )} */}
          </div>

          <div className='modal-footer'>
            {filter.fromDate || filter.toDate ? (
              <button
                id='btnProductClose'
                className='btn explore-btn-outline btn-sm'
                data-kt-menu-dismiss='true'
                onClick={handleClear}
              >
                Clear
              </button>
            ) : (
              <button
                id='btnProductClose'
                className='btn explore-btn-outline btn-sm'
                data-kt-menu-dismiss='true'
              >
                Close
              </button>
            )}
            <button
              id='btnProductAdd'
              className='btn btn-primary btn-sm ms-5'
              data-kt-menu-dismiss='true'
              onClick={() => onFilterChange(filter)}
              disabled={error}
            >
              Apply
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DateRangeFilter

const formatDate = (date: any) => {
  if (date) {
    return moment(date, 'YYYY-MM-DD')
  }
  return null
}
